var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansExistingPatients({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.05,
    height: 73.31,
    viewBox: "0 0 70.05 73.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.31,28.55a1.46,1.46,0,0,0-1.78.52,20.85,20.85,0,0,1-35,0,1.46,1.46,0,0,0-1.78-.52A24.87,24.87,0,0,0,.29,51.49v9.07A12.42,12.42,0,0,0,12.75,73H57.3A12.5,12.5,0,0,0,69.76,60.56V51.49A24.87,24.87,0,0,0,54.31,28.55Z",
    fill: "none",
    stroke: "#1c2026",
    strokeMiterlimit: 10,
    strokeWidth: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.34,30.74A22.82,22.82,0,0,0,3.15,51.8v2.65c0,1.34.05,3.23.11,5.78A11.37,11.37,0,0,0,14.67,71.55H55.38A11.43,11.43,0,0,0,66.79,60.23c.06,0,.11-5.69.11-5.75V51.8A22.82,22.82,0,0,0,52.71,30.74a1.35,1.35,0,0,0-1.63.49,19.19,19.19,0,0,1-32.11,0A1.35,1.35,0,0,0,17.34,30.74Z",
    fill: "none",
    stroke: "#30322b",
    strokeMiterlimit: 10,
    strokeWidth: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.94,32.94A20.77,20.77,0,0,0,6,52.11v2.47c0,1.27.1,3,.22,5.32A10.31,10.31,0,0,0,16.6,70.09H53.46A10.37,10.37,0,0,0,63.82,59.9c.12,0,.22-5.17.22-5.29v-2.5A20.77,20.77,0,0,0,51.11,32.94a1.22,1.22,0,0,0-1.47.44,17.53,17.53,0,0,1-29.23,0A1.22,1.22,0,0,0,18.94,32.94Z",
    fill: "none",
    stroke: "#444430",
    strokeMiterlimit: 10,
    strokeWidth: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.53,35.13A18.71,18.71,0,0,0,8.87,52.41v2.3c0,1.2.15,2.81.32,4.86a9.27,9.27,0,0,0,9.34,9.05h33a9.31,9.31,0,0,0,9.33-9.05,43.21,43.21,0,0,0,.32-4.84V52.41A18.71,18.71,0,0,0,49.52,35.13a1.12,1.12,0,0,0-1.33.41,15.87,15.87,0,0,1-26.33,0A1.12,1.12,0,0,0,20.53,35.13Z",
    fill: "none",
    stroke: "#575536",
    strokeMiterlimit: 10,
    strokeWidth: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.13,37.32a16.69,16.69,0,0,0-10.4,15.4v2.12a38.7,38.7,0,0,0,.43,4.39,8.22,8.22,0,0,0,8.29,7.93H49.61a8.26,8.26,0,0,0,8.28-7.93c.23,0,.43-4.14.43-4.37V52.72a16.69,16.69,0,0,0-10.4-15.4,1,1,0,0,0-1.17.37,14.21,14.21,0,0,1-23.45,0A1,1,0,0,0,22.13,37.32Z",
    fill: "none",
    stroke: "#6b673b",
    strokeMiterlimit: 10,
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.73,39.52A14.62,14.62,0,0,0,14.59,53V55a22.3,22.3,0,0,0,.54,3.94c0,3.8,3.51,6.79,7.25,6.79H47.69c3.74,0,7.23-3,7.23-6.79.3,0,.54-3.62.54-3.92V53a14.62,14.62,0,0,0-9.14-13.51.86.86,0,0,0-1,.33,12.57,12.57,0,0,1-20.57,0A.86.86,0,0,0,23.73,39.52Z",
    fill: "none",
    stroke: "#7f7940",
    strokeMiterlimit: 10,
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.33,41.71a12.59,12.59,0,0,0-7.88,11.63v1.75a14.2,14.2,0,0,0,.64,3.48c0,3.16,3.1,5.66,6.21,5.66H45.77c3.11,0,6.19-2.55,6.19-5.66.35,0,.64-3.11.64-3.46V53.34a12.59,12.59,0,0,0-7.88-11.63.77.77,0,0,0-.86.29,10.91,10.91,0,0,1-17.67,0A.77.77,0,0,0,25.33,41.71Z",
    fill: "none",
    stroke: "#938b45",
    strokeMiterlimit: 10,
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.93,43.9a10.53,10.53,0,0,0-6.62,9.75v1.57a8.74,8.74,0,0,0,.75,3c0,2.53,2.68,4.52,5.17,4.52H43.84c2.49,0,5.15-2,5.15-4.52.41,0,.75-2.6.75-3V53.65a10.53,10.53,0,0,0-6.62-9.75.64.64,0,0,0-.7.26,9.29,9.29,0,0,1-14.79,0A.64.64,0,0,0,26.93,43.9Z",
    fill: "none",
    stroke: "#a79d4a",
    strokeMiterlimit: 10,
    strokeWidth: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.53,46.1A8.48,8.48,0,0,0,23.17,54v1.4A5.18,5.18,0,0,0,24,57.9c0,1.9,2.26,3.4,4.13,3.4H41.92c1.87,0,4.1-1.53,4.1-3.4.47,0,.86-2.07.86-2.54V54a8.48,8.48,0,0,0-5.36-7.85.53.53,0,0,0-.55.21A7.26,7.26,0,0,1,35,49.15a7.27,7.27,0,0,1-6-2.84A.53.53,0,0,0,28.53,46.1Z",
    fill: "none",
    stroke: "#bbaf4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.12,48.29a6.43,6.43,0,0,0-4.09,6v1.22a3.12,3.12,0,0,0,1,2.09c0,1.27,1.85,2.26,3.09,2.26H40c1.24,0,3.06-1,3.06-2.26.52,0,1-1.56,1-2.09V54.26a6.43,6.43,0,0,0-4.09-6,.42.42,0,0,0-.4.18,6.05,6.05,0,0,1-9,0A.42.42,0,0,0,30.12,48.29Z",
    fill: "none",
    stroke: "#cec055",
    strokeMiterlimit: 10,
    strokeWidth: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.72,50.48a4.39,4.39,0,0,0-2.83,4.09v1A1.85,1.85,0,0,0,30,57.24c0,.63,1.43,1.13,2,1.13h6.07c.62,0,2-.51,2-1.13.59,0,1.07-1.05,1.07-1.63v-1a4.39,4.39,0,0,0-2.83-4.09.43.43,0,0,0-.25.14,4,4,0,0,1-3,1.18A4.07,4.07,0,0,1,32,50.62.43.43,0,0,0,31.72,50.48Z",
    fill: "none",
    stroke: "#e2d25a",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.73,52.67c-.34.59-3.07.59-3.41,0a2.35,2.35,0,0,0-1.57,2.21v.85a1.18,1.18,0,0,0,1.18,1.18h4.19a1.18,1.18,0,0,0,1.18-1.18v-.85A2.35,2.35,0,0,0,36.73,52.67Z",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 17.7,
    r: 17.41,
    transform: "translate(-4.11 14.75) rotate(-22.5)",
    fill: "none",
    stroke: "#1c2026",
    strokeMiterlimit: 10,
    strokeWidth: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 17.7,
    r: 15.16,
    transform: "matrix(0.92, -0.38, 0.38, 0.92, -4.11, 14.75)",
    fill: "none",
    stroke: "#3b3c2e",
    strokeMiterlimit: 10,
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 17.7,
    r: 12.91,
    transform: "translate(-4.11 14.75) rotate(-22.5)",
    fill: "none",
    stroke: "#5a5836",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 17.7,
    r: 10.66,
    transform: "translate(-4.11 14.75) rotate(-22.5)",
    fill: "none",
    stroke: "#79743e",
    strokeMiterlimit: 10,
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 17.7,
    r: 8.41,
    fill: "none",
    stroke: "#999047",
    strokeMiterlimit: 10,
    strokeWidth: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 17.7,
    r: 6.16,
    fill: "none",
    stroke: "#b8ac4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 17.7,
    r: 3.91,
    fill: "none",
    stroke: "#d7c857",
    strokeMiterlimit: 10,
    strokeWidth: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.03,
    cy: 17.7,
    r: 1.66,
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansExistingPatients);
export default __webpack_public_path__ + "static/media/physiciansExistingPatients.605fd08b1e55244efb9f9374a1868f38.svg";
export { ForwardRef as ReactComponent };